/**
 * Formats a string with placeholders using an array of provided strings
 * @param input Text to format
 * @param values Array of all the values to insert
 * @returns Resulting formatted text
 */
export default function format(input: string, values: string[]): string {
    return input.replace(/{(\d+)}/g, (match: string, number: number) => (typeof values[number] != 'undefined' ? values[number] : match));
}
